(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('prefers-reduced-motion: reduce').matches;
  }

  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-sm-size-guide]');
    if (!root) return;

    var link = e.target.closest('a[href^="#"]');
    if (!link) return;

    var id = link.getAttribute('href');
    if (!id || id === '#') return;

    var target = root.querySelector(id);
    if (!target) return;

    e.preventDefault();

    target.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });

    try {
      history.replaceState(null, '', id);
    } catch (err) {}

    var tocDetails = link.closest('details');
    if (tocDetails && tocDetails.open) tocDetails.open = false;
  });
})();
